import _ from 'lodash'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */

/** API */
import ComponentApi from 'api/components-api'
import BranchApi from 'api/setting/branch-service-points/branch.api'
import { routeName } from 'routes/routes-name'

/** UTILS || SLICE */
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Grid, InputAdornment } from '@mui/material'
import HeaderCard from 'component/CardCustom/HeaderCard'
import { notiError } from 'component/notifications/notifications'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import MainButton from 'new-components/buttons/main-button'
import TextInput from 'new-components/inputs/text-input'
import Loading from 'component/Loading'
import AlertModal from 'new-components/modal/alert-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

export default function Branch() {
  const history = useHistory()
  const { t } = useTranslation()

  const [branch, setBranch] = useState([])
  const [loading, setLoading] = useState(false)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(100)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('branchId')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')
  const [provinces, setProvinces] = useState<any[]>([])

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')


  const loadData = async () => {
    setLoading(true)
    try {
      const resp = await BranchApi.findAll({
        page,
        pageLimit,
        search,
        sortBy,
        sortType,
        status: status === 'ALL' ? '' : status,
        listOnly: true
      })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setBranch(resp.data || [])
      } else {
        setBranch([])
      }
    } catch (error) {
      notiError('ERROR')
      setBranch([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])

  const loadProvinces = async () => {
    const resProvinces = await ComponentApi.findAllProvinces()
    if (resProvinces.status === 200) {
      setProvinces(resProvinces.data)
    }
  }

  useEffect(() => {
    loadProvinces()
  }, []);

  const onActive = () => {
    if (id) {
      BranchApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('BRANCH.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('BRANCH.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onDelete = () => {
    if (id) {
      BranchApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('BRANCH.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('BRANCH.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    history.push(routeName.branch + '/update', data)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: '#' },
    { id: 'branchName', disablePadding: false, label: t('BRANCH.TABLE.CELL.BRANCH_NAME') },
    { id: 'branchNameEn', disablePadding: false, label: t('BRANCH.TABLE.CELL.BRANCH_NAME_EN') },
    { id: 'branchProvince', disablePadding: false, label: t('BRANCH.TABLE.CELL.BRANCH_PROVINCE') },
    { id: 'branchPhone', disablePadding: false, label: t('BRANCH.TABLE.CELL.BRANCH_PHONE') },
    { id: 'updatedBy', disablePadding: false, label: t('BRANCH.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { branchId, branchName, branchNameEn, provinceId, branchPhone, updatedBy, updatedAt } = objData
    const objRenderData = {
      key: branchId,
      id: branchId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: branchName },
        { option: 'TEXT', align: 'left', label: branchNameEn },

        { option: 'TEXT', align: 'left', label: provinceId ? _.get(_.find(provinces, (province) => province.provinceId === provinceId), 'provinceNameTh') : t('NOT_SPECIFIED') },
        { option: 'TEXT', align: 'left', label: branchPhone },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.diagnosisName)
    setNameEn(obj.diagnosisNameEn)
  }

  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`BRANCH.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`BRANCH.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { diagnosisName: name, diagnosisNameEn: nameEn && `(${nameEn})`, status: t(`BRANCH.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <HeaderCard text={t('BRANCH.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={2}>
            <TextInput
              label={t('BRANCH.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          {/* <Grid item xs={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                  setPage(1)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid> */}
          <Grid item xs={1}>
            <MainButton
              title={t('INPUT.SEARCH')}
              type='primary'
              variant='contained'
              style={{ width: '120px' }}
              onClick={() => {
                setPage(1)
                loadData()
              }} />
          </Grid>
        </Grid>
        <Box paddingTop="24px" position="relative">
          <Loading show={loading} />
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={branch.map((val, i) => {
              return renderData(val, i)
            })}
          />
        </Box>
      </Box>
    </Box>
  )
}
